import styled, { css } from 'styled-components'

export const CopyrightFooter = styled.div`
  text-align: center;

  ${({ variant }) => variant === 'desktop' ? css`
    display: block;
    margin-top: auto;
    padding: 16px 24px 24px;

    @media (max-width: 990px) {
      display: none;
    }
  ` : css`
    display: none;
    padding: 16px 16px 24px;
    margin-bottom: 65px;
    background-color: ${({ theme }) => theme.colors.backgroundColor};
    border-top: 1px solid rgba(0, 0, 0, 0.08);

    @media (max-width: 990px) {
      display: block;
    }
  `}
`

export const CopyrightTextBox = styled.div`
  ${({ variant }) => variant === 'desktop' && css`
    display: inline-block;
    max-width: 90%;
    padding: 12px 18px;
    border-radius: 10px;
    background-color: rgba(0, 0, 0, 0.62);
    box-shadow: 0 4px 14px rgba(0, 0, 0, 0.35);
    backdrop-filter: blur(4px);
  `}
`

export const CopyrightText = styled.p`
  margin: 0;
  font-size: 11px;
  line-height: 1.5;

  ${({ variant }) => variant === 'desktop' ? css`
    color: rgba(255, 255, 255, 0.95);
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.45);
  ` : css`
    color: #6b6b6b;
  `}
`

export const FooterLinks = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
  gap: 6px 10px;
  margin-top: 8px;
`

export const FooterLink = styled.button`
  margin: 0;
  padding: 0;
  border: none;
  background: none;
  font-size: 11px;
  font-weight: 600;
  line-height: 1.5;
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;

  ${({ variant, theme }) => variant === 'desktop' ? css`
    color: rgba(255, 255, 255, 0.95);
    text-shadow: 0 1px 3px rgba(0, 0, 0, 0.45);

    &:hover {
      color: #ffffff;
    }
  ` : css`
    color: ${theme.colors.primaryButtCol};

    &:hover {
      color: ${theme.colors.hoverButtCol};
    }
  `}
`

export const FooterLinkDivider = styled.span`
  font-size: 11px;
  line-height: 1;

  ${({ variant }) => variant === 'desktop' ? css`
    color: rgba(255, 255, 255, 0.7);
  ` : css`
    color: #9a9a9a;
  `}
`
